if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-icon-bubble', // ID = id of the element that needs to be updated
          section: 'cart-icon-bubble', // SECTION = name of the Shopify file that needs to be rendered
          selector: '.shopify-section', // Selector
        }
      ]
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Passing no argument will hide the error message if one was on screen because errorText defaults to false
      this.handleErrorMessage();

      // Disabling the button temporarily so that the request can be processed
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        }
      };

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      } else {
        formData.append('sections', this.getSectionsToRender().map(section => section.id));
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.dispatchEvent(
              new CustomEvent(PUB_SUB_EVENTS.cartError, {
                bubbles: true,
                detail: { message: response.message, error: response.description },
              })
            );
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          this.error = false;

          if (this.cart) {
            this.cart.renderContents(response);
          } else {
            this.getSectionsToRender().forEach((section) => {
              document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
            });
            // Redirect to cart page
            window.location.href = window.routes.cart_url;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally((response) => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorText = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorText);

      this.errorMessage.textContent = errorText ? errorText : '';
    }
  });
}
